import routes from '@modules/subproperty-settings/program-settings/program-settings-routes';
import store from '@modules/subproperty-settings/program-settings/program-settings-store';

export default {
  routes,
  store
};
